<template>
  <span
    v-if="!isValueEmpty"
    :class="{'text-success': value > 0}"
  >{{ str }}{{ afterText }}</span>
  <span v-else>-</span>
</template>

<script>
import helper from '../../../../../../../resources/js/mixins/helper'

/**
 * Выводит процент изменения позиции.
 */
export default {
  name: 'PositionsPercentDiff',
  mixins: [helper],
  props: {
    /**
     * Значение изменения позиции.
     */
    value: {
      validator (value) {
        return typeof value === 'number' || value === null
      },
      required: true
    },
    /**
     * Текст после значения.
     */
    afterText: {
      type: String,
      default: '%'
    },
    /**
     * Показывает динамику изменения.
     */
    dynamic: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    /**
     * Округленное значение.
     *
     * @returns {number}
     */
    valueRound () {
      return this.round(this.value)
    },
    /**
     * Текст для вывода.
     *
     * @returns {string}
     */
    str () {
      return this.valueRound > 0 && this.dynamic ? `+${this.valueRound}` : this.valueRound.toString()
    },
    /**
     * Пустое ли значение.
     *
     * @returns {boolean}
     */
    isValueEmpty () {
      return this.empty(this.value)
    }
  }
}
</script>
